<template>
  <base-dialog
    v-model="dialog.show"
    max-width="500px"
    min-width="300px"
    scrollable
    title="Thông tin"
    width="50%"
  >
    <base-form ref="form" lazy-validation @submit.stop="onSubmit">
      <v-row no-gutters>
        <v-col cols="12">
          <field-group
            v-model="dialog.data.name"
            autofocus
            :error-messages="dialog.error.name"
            filled
            label="Tên"
            no-label
          ></field-group>
        </v-col>
        <v-col cols="12">
          <field-group
            :value="dialog.data.type"
            filled
            label="Loại"
            no-label
            readonly
          ></field-group>
        </v-col>
        <v-col cols="12">
          <field-group
            v-model="dialog.data.meta.field_name"
            :items="fieldsSelect"
            label="Trường hiển thị"
            no-label
            filled
            item-text="name"
            item-value="code"
            :error-messages="dialog.error['meta.field_name']"
            typeInput="v-select"
            @change="onChangeParams"
          >
          </field-group>
        </v-col>
        <v-col cols="12">
          <field-group
            :value="dialog.data.meta.srid"
            filled
            :label="$t('layer.projection')"
            no-label
            readonly
          ></field-group>
        </v-col>
        <v-col cols="12">Vùng bao Hệ toạ độ 4326</v-col>
        <v-col cols="5">
          <field-group
            v-model="dialog.data.meta.bbox_4326[0]"
            autofocus
            :error-messages="dialog.error['meta.bbox_4326.0']"
            filled
            label="Min X"
            no-label
            type="number"
          ></field-group>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="5">
          <field-group
            v-model="dialog.data.meta.bbox_4326[1]"
            autofocus
            :error-messages="dialog.error['meta.bbox_4326.1']"
            filled
            label="Min Y"
            no-label
            type="number"
          ></field-group>
        </v-col>
        <v-col cols="5">
          <field-group
            v-model="dialog.data.meta.bbox_4326[2]"
            autofocus
            :error-messages="dialog.error['meta.bbox_4326.2']"
            filled
            label="Max X"
            no-label
            type="number"
          ></field-group>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="5">
          <field-group
            v-model="dialog.data.meta.bbox_4326[3]"
            autofocus
            :error-messages="dialog.error['meta.bbox_4326.3']"
            filled
            label="Max Y"
            no-label
            type="number"
          ></field-group>
        </v-col>
        <v-col cols="12">
          <field-group
            :value="features_count"
            filled
            label="Số lượng đối tượng"
            no-label
            readonly
          >
          </field-group>
        </v-col>
        <v-col cols="12">
          <field-group
            :value="fields.length"
            filled
            label="Số lượng trường dữ liệu"
            no-label
            readonly
          >
          </field-group>
        </v-col>
      </v-row>
    </base-form>
    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :loading="dialog.loading"
        outlined
        :type-action="EDIT_TYPE.UPDATE"
        @click="onSubmit"
      >
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { sdk } from '@service/http/axios'
import { EDIT_TYPE } from '@constant'
import { merge } from 'lodash'
export default {
  props: {
    fields: { type: Array, required: true },
    features_count: { type: Number, required: true },
  },
  data: () => ({
    EDIT_TYPE,
    dialog: {
      show: false,
      loading: false,
      data: {
        meta: {
          bbox_4326: [],
        },
      },
      error: {},
    },
  }),
  watch: {},
  computed: {
    fieldsSelect() {
      return this.fields.filter(
        (x) => !['region-field', 'geometry'].includes(x.type)
      )
    },
  },
  methods: {
    open(item) {
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      if (!item.meta || Array.isArray(item.meta)) {
        item.meta = {}
      }
      if (!item.meta.bbox_4326) item.meta.bbox_4326 = []
      let data = merge(item)

      this.$set(this.dialog, 'data', data)
    },
    dialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: { meta: { bbox_4326: [] } },
        error: {},
      }
      this.$emit('reset')
    },
    async onSubmit() {
      this.dialog.error = {}
      if (!(await this.$refs.form.validate())) return
      try {
        this.dialog.data.meta.bbox_4326 = this.dialog.data.meta.bbox_4326.map(
          (x) => parseFloat(x)
        )
        let data = Object.assign({}, this.dialog.data)
        let res = await sdk.request({
          url: `datastore-details/${this.dialog.data.id}/`,
          method: 'put',
          data: data,
        })
        if (res && !res.error) {
          this.dialogClose()
          this.$store.dispatch('notify/success', {
            message: res.data.message,
          })
          this.getData()
        }
      } catch (error) {
        if (error.response.status == 422) {
          const response = error.response
          this.dialog.error = response.data.errors
        }
      } finally {
        this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
    onChangeParams(field_name) {
      this.$set(this.dialog.data.meta, 'field_name', field_name)
    },
  },
}
</script>

<style scoped></style>
